import { c as _c } from "react/compiler-runtime";
import { Draggable, type DraggableProvided, type DraggableStateSnapshot } from "@hello-pangea/dnd";
import { Stack } from "@mui/material";
import React from "react";
type DraggableItemProps = {
  id: string;
  index: number;
  isDragDisabled?: boolean;
  children: (provided: DraggableProvided, snapshot: DraggableStateSnapshot) => React.ReactNode;
};
export const DraggableItem: React.FC<DraggableItemProps> = t0 => {
  const $ = _c(7);
  const {
    id,
    index,
    isDragDisabled,
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = (provided, snapshot) => <Stack ref={provided.innerRef} {...provided.draggableProps} sx={{
      opacity: snapshot.isDragging ? 0.5 : 1,
      transform: snapshot.isDragging ? "scale(1.02)" : "none",
      transition: snapshot.isDragging ? "opacity 0.2s, transform 0.2s" : "none"
    }}>{children(provided, snapshot)}</Stack>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== id || $[3] !== index || $[4] !== isDragDisabled || $[5] !== t1) {
    t2 = <Draggable key={id} draggableId={id} index={index} isDragDisabled={isDragDisabled}>{t1}</Draggable>;
    $[2] = id;
    $[3] = index;
    $[4] = isDragDisabled;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};